module.exports = __webpack_public_path__ + "img/shelftop.3589fdaf.png";